import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {HttpService} from "../http/http.service";
import {Message, MessagePage} from "./message";


@Injectable()
export class MessageService {
  private url = '/api/messages';

  constructor(private httpService: HttpService) {
  }

  sendMessage(message: Message): Observable<Message> {
    return this.httpService.post(`${this.url}`, message).map(res => res.json() as Message);
  }

  get(type: string, page: number, search: string): Observable<MessagePage> {
    return this.httpService.get(`${this.url}/${type}?page=${page}` + (search ? `&search=${search}` : ''))
      .map(res => res.json() as MessagePage)
  }

  check(id: number) {
    return this.httpService.put(`${this.url}/check/${id}`, null)
      .map(res => res.json() as Message);
  }
}



// WEBPACK FOOTER //
// ./src/app/service/message/message.service.ts